import { initialFolder } from "../../../constants";
import { 
    SET_LOADING,
    SET_ALL_ARTIST_LIST,
    SET_ALL_ARTIST_LIST_META,
    APPEND_ALL_ARTIST_LIST,
    SET_CURRENT_FOLDER,
    SET_FOLDER_LIST,
    SET_FOLDER_STACK,
    SET_LIST_TYPE,
    SET_SELECTED_FOLDER,
    SET_SELECTED_SAVED_FOLDER,
    POP_LAST_FOLDER,
    SET_SELECTED_ARTISTS,
} from "../../actions/folder/types";

const INITIAL_STATE = {
    loading: false,
    allArtistList: [],
    allArtistListMetaData: {
        loading: false, hasMore: true
    },
    listType: 'grid',
    folderViewList: [],
    currentFolder: initialFolder,
    selectedFolder: initialFolder,
    selectedSavedFolder: initialFolder,
    folderStack: [initialFolder],
    selectedArtists: []
}

const FolderReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ALL_ARTIST_LIST: {
            return {
                ...state,
                allArtistList: action.payload
            }
        }
        case SET_ALL_ARTIST_LIST_META: {
            return {
                ...state,
                allArtistListMetaData: action.payload
            }
        }
        case APPEND_ALL_ARTIST_LIST: {
            return {
                ...state,
                allArtistList: [ ...state.allArtistList, ...action.payload]
            }
        }
        case SET_FOLDER_STACK: {
            return {
                ...state,
                folderStack: action.payload
            }
        }
        case SET_SELECTED_FOLDER: {
            return {
                ...state,
                selectedFolder: action.payload
            }
        }
        case SET_SELECTED_SAVED_FOLDER: {
            return {
                ...state,
                selectedSavedFolder: action.payload
            }
        }
        case SET_FOLDER_LIST: {
            return {
                ...state,
                folderViewList: action.payload
            }
        }
        case SET_CURRENT_FOLDER: {
            return setCurrentFolder(state, action)
        }
        case POP_LAST_FOLDER: {
            return popLastFolder(state)
        }
        case SET_SELECTED_ARTISTS: {
            return {
                ...state,
                selectedArtists: action.payload
            }
        }
        case SET_LIST_TYPE: {
            return {
                ...state,
                listType: action.payload
            }
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload
            }
        }
        default: {
            return state;
        }
    }
}

const setCurrentFolder = (state, action) => {
    let tempStack = state.folderStack;
    const index = tempStack.findIndex((item) => item.id === action.payload.id);
    if (index === -1) tempStack = [ ...tempStack, action.payload];
    else tempStack = tempStack.slice(0, index + 1);

    return {
        ...state,
        currentFolder: action.payload,
        folderStack: tempStack
    }
}

const popLastFolder = (state) => {
    const tempStack = state.folderStack.slice(0, -1);

    return {
        ...state,
        currentFolder: tempStack[tempStack?.length - 1],
        folderStack: tempStack
    }
}

export default FolderReducer;